import { ReactNode, memo } from "react";
import { useHistory } from "react-router-dom";
import { Spin } from "antd";

import { Icon } from "../../icon";

interface Props {
  children?: ReactNode;
  title?: string;
  loading?: boolean;
  backLink?: string;
}

const ProcedureLayout = memo((props: Props) => {
  const {
    loading = false,
    title,
    children,
    backLink = "",
    ...restProps
  } = props;
  const { goBack, push } = useHistory();

  return (
    <Spin spinning={loading}>
      <div {...restProps} className="pd15">
        <div className="PageHead flex-center">
          <div className="title" style={{ margin: 0 }}>
            <div
              className="btnBack"
              onClick={backLink ? () => push(backLink ?? "") : goBack}
            >
              <Icon.ArrowLeft />
            </div>
            {title}
          </div>
        </div>
        {children}
      </div>
    </Spin>
  );
});

export default ProcedureLayout;
